exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flow[data-v-cb082c1e]{color:#000;width:50%;z-index:920;position:absolute;height:80%;overflow-y:auto}.page-picker-wrapper[data-v-cb082c1e]{height:100%;padding:10px 4% 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-cb082c1e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/address/address.vue
// module id = 56
// module chunks = 0